import React from "react";
import { 
  ChevronRight, 
  LayoutDashboard, 
  Users, 
  Image, 
  Calendar, 
  UserCircle,
  Video,
  MessageCircle
} from "lucide-react";

export const NAV_ITEMS = [
  { id: "overview", label: "Overview", icon: LayoutDashboard },
  { id: "booth-members", label: "Booth Members", icon: Users },
  { id: "exhibitor-profile", label: "Exhibitor Profile", icon: UserCircle },
  { id: "booth-materials", label: "Booth Materials", icon: Video },
  { id: "promo-banner", label: "Promotional Banner", icon: Image },
  { id: "leads", label: "Leads", icon: Users },
  { id: "inquiries", label: "Inquiries", icon: MessageCircle },
  { id: "meetings", label: "Meetings", icon: Calendar },
];

function Sidebar({ activeTab, onTabChange, isMobile, features = [] }) {
  // Filter nav items based on both permissions and category features
  const filteredNavItems = NAV_ITEMS.filter((item) => {
    if (item.id === "booth-materials") {
      const v = features.find(f => f.key === "videos");
      const c = features.find(f => f.key === "collateral");
      return (v?.enabled === 1 && v?.visible === 1) || (c?.enabled === 1 && c?.visible === 1);
    }

    const featureKeyMap = {
      "leads": "lead_scanning",
      "promo-banner": "promotional_banner"
    };

    const featureKey = featureKeyMap[item.id] || item.id;
    const feature = features.find(f => f.key === featureKey);

    if (feature) {
        return feature.enabled === 1 && feature.visible === 1;
    }

    return true; 
  });

  return (
    <aside className={`${isMobile ? "w-full" : "w-64 flex-shrink-0"}`}>
      <nav className="bg-[#f1f8ff] border border-gray-100 rounded-lg overflow-hidden shadow-soft">
        {filteredNavItems.map((item, index) => {
          const isActive = activeTab === item.id;

          return (
            <button
              key={item.id}
              onClick={() => onTabChange(item.id)}
              className={`w-full px-4 py-2.5 text-sm font-bold flex items-center gap-3 rounded-lg justify-between transition-all duration-200 border border-transparent ${
                isActive
                  ? "bg-[#435e70] text-white shadow-md shadow-[#435e70]/20"
                  : "text-gray-600 hover:text-[#435e70] hover:bg-[#435e70]/5"
              }`}
            >
              <div className="flex items-center gap-3">
                {item.icon && <item.icon size={18} strokeWidth={isActive ? 2.5 : 2} />}
                <span>{item.label}</span>
              </div>
              {isActive && <ChevronRight size={14} strokeWidth={3} className="opacity-70" />}
            </button>
          );
        })}
      </nav>
    </aside>
  );
}

export default Sidebar;
